import { scene_1_hero } from "./partials/scene-1-hero";
import { scene_2_rolling_bottle_and_icons } from "./partials/scene-2-roling-bottle-and-icons";
import { scene_5_animated } from "./partials/scene-5";
import { scene6 } from "./partials/scene-6";
import { splitText } from "./partials/splitText";
import { fixedHeadersAnimated } from "./partials/fixed-headers";
// import { darkToNavExchange } from "./partials/light-dark-nav-exchange";
import { sceneEvidence } from "./partials/scene-evidence";
import { imageSlideScene } from "./partials/image-slide-scene";
import { sceneSignatureServes } from "./partials/scene-signature-serves";
import { sceneHeroCardboard } from "./partials/scene-hero-cardboard";

export function allAnimationsAfter() {
  ScrollTrigger.config({
    ignoreMobileResize: true, // 🧰 GSAP >= 3.11
    autoRefreshEvents: "visibilitychange,DOMContentLoaded,load", // no resize spam
  });
  sceneHeroCardboard();
  scene_1_hero();
  scene_2_rolling_bottle_and_icons();
  scene_5_animated();

  fixedHeadersAnimated();

  sceneEvidence();
  imageSlideScene();
  sceneSignatureServes();
  scene6();
}
